import { defaultDiscriminator, maxBy } from './maxBy.js';
export const minBy = (discriminator = defaultDiscriminator) => maxBy((_) => -discriminator(_));
export const min = minBy();
//# sourceMappingURL=minBy.js.map